var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.cancel),expression:"cancel"}],staticClass:"field-box",class:{ 'field-box--error' : _vm.hasError }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }